import type {ListServiceFunctionsSearchInput} from "./list-service-functions.schema";

import {listServiceFunctions} from "@project/sdk/engineering";
import {ListServiceFunctionsResponse} from "@project/sdk/engineering/zod";
import {queryOptions} from "@tanstack/react-query";

import {queryPolicyDefaults} from "../../../../../shared/query/query-policies";
import {serviceFunctionKeys} from "../../../serviceFunction-keys";

import {listServiceFunctionsSearchSchema} from "./list-service-functions.schema";

export function listServiceFunctionsQueryOptions(rawInput: ListServiceFunctionsSearchInput) {
  const params = listServiceFunctionsSearchSchema.parse(rawInput);

  return queryOptions({
    ...queryPolicyDefaults.warm,
    staleTime: 0,
    queryKey: serviceFunctionKeys.list(params),
    queryFn: async ({signal}) =>
      ListServiceFunctionsResponse.parse(await listServiceFunctions(params, {signal})),
  });
}
